<template>
  <div class="section customer-form">
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="80px" label-position="left" class="form-item-350">
        <el-form-item :label="$t('SeaExport.CustomerLevel')" class="margin-Right50">
          <cargo-advance-select
            no="customerTypeId"
            :allow-create="false"
            filterable
            :cache="false"
            :default-value="form.customerTypeId"
            clearable
            :tag-name="isZh ? 'chineseName' : 'englishName'"
            tag-value="typeId"
            :static-options="customerTypeList"
            @parentCallBack="customerTypeIdFunc"
          />
        </el-form-item>
        <el-form-item :label="$t('Partners.departmentBelonging')">
          <div style="display: flex;width: 600px;">
            <el-select no="ownerDepartment" :value="form.ownerDepartment||''" :disabled="departmentList.length===0" style="width: 220px;" @input="onDepartmentInput">
              <el-option v-for="(item,index) in departmentList" :key="index" :label="isZh?item.chineseName:item.englishName" :value="item.departmentId" />
            </el-select>
            <el-checkbox v-model="form.peer" no="peer" style="margin-left: 10px">{{ $t('Partners.peers') }}</el-checkbox>
            <span v-if="showCompanyUser" style="margin-right: 10px">{{ $t('Payment.solicitationType') }}</span>
            <el-checkbox v-if="showCompanyUser" v-model="form.seftCanvass" :disabled="isSalesForSzfs" no="seftCanvass" style="margin-right: 10px">{{ $t('Partners.customerSpace3') }}</el-checkbox>
            <el-checkbox v-if="showCompanyUser && !isSalesForSzfs" v-model="form.designated" no="designated" style="margin-right: 10px">{{ $t('Partners.customerSpace2') }}</el-checkbox>
          </div>
        </el-form-item>
        <br>
        <el-form-item v-if="!showCompanyUser" :label="$t('Payment.solicitationType')" class="margin-Right50">
          <div style="display: flex">
            <el-checkbox v-model="form.seftCanvass" :disabled="isSalesForSzfs" no="seftCanvass" style="margin-right: 10px">{{ $t('Partners.customerSpace3') }}</el-checkbox>
            <el-checkbox v-if="!isSalesForSzfs" v-model="form.designated" no="designated" style="margin-right: 10px">{{ $t('Partners.customerSpace2') }}</el-checkbox>
            <span v-if="form.seftCanvass" style="display: inline-block;width: 65px">{{ $t('Payment.sales') }}</span>
            <cargo-user-select
              v-if="form.seftCanvass"
              no="sales"
              :method-params="{category:'role',shape:'sales'}"
              :default-value="form.sales||''"
              @change="p=>{form.sales=p.value||0}"
            />
          </div>
        </el-form-item>
        <el-form-item label-width="0" class="form-item-430">
          <div style="display: flex">
            <el-checkbox v-model="form.iTraceService" no="iTraceService" style="width: 80px;">i-trace</el-checkbox>
            <span style="width: 100px;display: inline-block">{{ $t('Partners.introductionDate') }}</span>
            <el-date-picker v-model="form.iTraceStartDate" no="iTraceStartDate" :disabled="!form.iTraceService" type="date" value-format="yyyy-MM-dd" />
          </div>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_SourceOfClient')">
          <cargo-advance-select
            no="customerSourceUuid"
            :select-type="selectTypeNames.basic_data_CustomerSource"
            filterable
            tag-value="uuid"
            :default-value="form.customerSourceUuid||''"
            @parentCallBack="p=>{form.customerSourceUuid= p.uuid}"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="grid-view">
      <div style="display:flex;flex-direction: row;height: 100%;">
        <div v-show="!isSalesForSzfs && (form.designated || showCompanyUser)" class="main-content" style="flex: 1;margin-right: 5px">
          <span class="title">{{ $t('Partners.destinationNominatedAgent') }}</span>

          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <div>
                <el-button no="showEditDialog" :disabled="readonly" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
                <el-button no="showEditDialog" :disabled="readonly" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
                <el-button no="remove" :disabled="readonly" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
              </div>
            </div>
          </div>
          <div class="grid-wrapper">
            <cargo-ag-grid
              :grid-options="gridOptions"
              :side-bar="sideBarDefs"
              :column-defs="columnDefs"
              :row-data="finalRowData"
              style="width:100%"
              @gridReady="params=>gridApi=params.api"
            />
          </div>
        </div>
        <div v-show="showCompanyUser" class="main-content" style="flex: 1;margin-left: 5px">
          <span class="title">{{ $t('Partners.theCorrespondingServicePartners') }}</span>
          <company-user-container ref="companyUserContainer" :action="action" />
        </div>
      </div>
      <div style="width: 50%;padding-right: 5px; padding-top: 5px">
        <span class="title">{{ $t('CargoMsg.Cargo_CustomerAssociatedFactory') }}</span>
        <div class="operations" style="margin-bottom: 5px">
          <div class="triggers">
            <div>
              <el-button no="factorySignAdd" :disabled="readonly" type="primary" @click="factorySignAddDialog">{{ $t('common.btn.new') }}</el-button>
              <el-button no="factorySignRemove" :disabled="readonly" type="danger" @click="factorySignAddRemove">{{ $t('common.btn.delete') }}</el-button>
            </div>
          </div>
        </div>
        <div class="grid-wrapper">
          <cargo-ag-grid
            :grid-options="factorySign.gridOptions"
            :side-bar="sideBarDefs"
            :column-defs="factorySign.columnDefs"
            :row-data="companyFactorySigns"
            style="width:100%"
            @gridReady="params=>factorySign.gridApi=params.api"
          />
        </div>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      class="customer-form"
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Payment.portOfDestination')">
            <cargo-advance-select
              no="destinationPort"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :callback-params="{key:'destinationPort'}"
              callback-method-type="value"
              :default-value="editDialog.form.destinationPort"
              style="width:260px"
              @parentCallBack="selectCargoItemOfDialog"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.isDefault')">
            <el-radio-group v-model="editDialog.form.defaultAgent" no="defaultAgent" @change="onDefaultChange">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('queryJob.nominatedAgent')">
            <cargo-advance-select
              no="destinationAgentId"
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{overseaAgent:true,active:true}"
              :default-value="editDialog.form.destinationAgentId||''"
              filterable
              style="width:260px;"
              @parentCallBack="p=>{editDialog.form.destinationAgentId=p.value||0}"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增关联工厂 -->
    <el-dialog
      v-el-drag-dialog
      class="customer-form"
      :visible.sync="factorySign.addDialog.visible"
      :title="factorySign.addDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Partners.Factory')">
            <cargo-advance-select
              no="destinationAgentId"
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{factorySign:true,active:true}"
              filterable
              :multiple="true"
              :default-multiple-value="factorySign.addDialog.factorySignValue"
              style="width:260px;"
              @parentCallBack="item=>factorySign.addDialog.factorySignValue=item.value"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveFactorySign">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="factorySign.addDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { cache } from '@/utils/cacheManager'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { getDepartmentByOfficeId } from '@/api/user'
import { getPortDestinationAgentList } from '@/api/partner/portDestinationAgent'
import companyUserContainer from '@/views/cargo/v0/Information/components/partner/companyUserContainer'
import { Company } from '@/class/model/mdm/Company'
import { TabError } from '@/utils/class/TabError'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { companyFactorySignByCompanyFunc } from '@/api/company'

export default {
  name: 'CustomerForm',
  components: { cargoAdvanceSelect, cargoUserSelect, companyUserContainer },
  props: {
    action: {
      type: String,
      required: true
    },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    const isZh = this.$i18n.locale === 'zh'
    return {
      isZh,
      cache: new Map(),
      departmentList: [],
      selectTypeNames: TYPE_NAMES,
      company: new Company().fillDefaultValue().getData(),
      form: {
        uuid: '',
        customerTypeId: 0,
        ownerDepartment: 0,
        peer: false,
        iTraceService: false,
        iTraceStartDate: '',
        seftCanvass: false,
        designated: false,
        companyUuid: '',
        customerSourceUuid: ''
      },
      showCompanyUser: false,
      customerTypeList: [],
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: this.$t('Payment.portOfDestination'),
          field: 'destinationPort',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultAgent',
          width: 100,
          cellRenderer: params => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        }, {
          headerName: this.$t('queryJob.nominatedAgent'),
          field: 'destinationAgentId',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('Payment.remarks'),
          field: 'remarks',
          width: 200
        }
      ],
      rowData: [],
      deletedPortDestinationAgentKeys: [],
      deletedFactorySignKeys: [],
      gridApi: null,
      factorySign: {
        gridApi: null,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        rowData: [],
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_FactoryName'),
            field: 'factorySignCmpIdx',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          }
        ],
        addDialog: {
          visible: false,
          title: '',
          factorySignValue: []
        }
      },
      editDialog: {
        visible: false,
        title: '',
        initialForm: {},
        form: {
          uuid: '',
          destinationPort: '',
          defaultAgent: false,
          destinationAgentId: 0,
          remarks: '',
          customerUuid: ''
        }
      },
      autoIncrementNum: new AutoIncrementNum(),
      isZy: false
    }
  },
  computed: {
    readonly() {
      return !this.action || this.action === 'look'
    },
    finalRowData() {
      return this.rowData.filter(p => p.todo !== 'remove')
    },
    companyFactorySigns() {
      return this.factorySign.rowData.filter(p => !p.deleted)
    }
  },
  created() {
    this.editDialog.initialForm = this.editDialog.form
    this.customerTypeList = getCacheListByKey(TYPE_NAMES.basic_data_CustomerType)
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        console.log('companyUserContainer')
        console.log(JSON.parse(JSON.stringify(row)))
        this.$refs['companyUserContainer'].onshow(row)
        this.company = row
        this.form = row.customerDetail
        this.showCompanyUser = Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1
        this.isZy = String(cache.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
        this.toQuery()
        this.editDialog.initialForm.customerUuid = this.form.uuid
      }
      this.getDepartmentList(row.branchId)
    },
    async getDepartmentList(officeId) {
      let data = this.cache.get('department/' + officeId)
      if (!data) {
        await getDepartmentByOfficeId(officeId).then(res => {
          data = res.data
          this.cache.set('department/' + officeId)
        })
      }
      this.departmentList = data
    },
    onDepartmentInput(value) {
      this.form.ownerDepartment = value
    },
    selectCargoItem(item) {
      this.form[item.key] = item.value
    },
    selectCargoItemOfDialog(item) {
      this.editDialog.form[item.key] = item.value
    },
    getSubmitData() {
      if (this.showCompanyUser) {
        if (this.form.seftCanvass) {
          if (this.company.companyUsers && this.company.companyUsers.length > 0) {
            let hasSales = false
            for (const item of this.company.companyUsers) {
              if (item.roleType === CargoOfRoleType.SALES_TYPE.code) {
                hasSales = true
                break
              }
            }
            if (!hasSales) {
              throw new TabError(this.$t('CargoMsg.Cargo_PleaseSelectedSalesForCustomer'), 'customerForm')
            }
          } else {
            throw new TabError(this.$t('CargoMsg.Cargo_PleaseSelectedSalesForCustomer'), 'customerForm')
          }
        }
      }
      if (this.isZy) {
        if (this.form.customerTypeId === '') {
          this.form.customerTypeId = 0
        }
        const customerTypeList = this.customerTypeList.filter(item => item.typeId === this.form.customerTypeId)
        if (customerTypeList.length === 0) {
          throw new TabError(this.$t('CargoMsg.Cargo_PleaseSelectedLevelForCustomer'), 'customerForm')
        }
      }
      if (this.form.iTraceService && !this.form.iTraceStartDate) {
        this.form.iTraceStartDate = DateUtils.formatStandardDate(new Date())
      }
      if (!this.form.seftCanvass) {
        this.form.sales = 0
      }
      if (this.rowData.length > 0) {
        this.form.portDestinationAgents = this.rowData
      }
      if (this.deletedPortDestinationAgentKeys.length > 0) {
        this.form.deletedPortDestinationAgentKeys = this.deletedPortDestinationAgentKeys
      }
      if (this.companyFactorySigns.length > 0) {
        this.form.companyFactorySigns = this.companyFactorySigns
      }
      if (this.deletedFactorySignKeys.length > 0) {
        this.form.deletedFactorySignKeys = this.deletedFactorySignKeys
      }
      const result = {
        customerDetail: this.form
      }
      if (this.showCompanyUser) {
        if (this.company.companyUsers && this.company.companyUsers.length > 0) {
          result.companyUsers = this.company.companyUsers
        }
        if (this.company.deletedCompanyUserKeys && this.company.deletedCompanyUserKeys.length > 0) {
          result.deletedCompanyUserKeys = this.company.deletedCompanyUserKeys
        }
      }
      return result
    },
    toQuery() {
      if (!this.form.uuid) return
      getPortDestinationAgentList({ customerUuid: this.form.uuid }).then(res => {
        for (const item of res.data) {
          item.seq = this.autoIncrementNum.getNextNum()
        }
        this.rowData = res.data
        this.deletedPortDestinationAgentKeys = []
      })
      companyFactorySignByCompanyFunc({ companyCmpIdx: this.company.cmpIdx }).then(res => {
        this.factorySign.rowData = res.data
        this.deletedFactorySignKeys = []
      })
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          seq: this.autoIncrementNum.getNextNum(),
          ...this.editDialog.initialForm,
          todo: 'new'
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.finalRowData[cell.rowIndex] : null
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...row }
        this.editDialog.form.todo = this.editDialog.form.todo || 'edit'
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    onDefaultChange() {
      // 移除校验（暂时注释掉，避免后续又要）
      // const form = this.editDialog.form
      // if (form.defaultAgent) {
      //   const existItem = this.rowData.find(p => p.defaultAgent && p.uuid !== form.uuid)
      //   if (existItem) {
      //     this.$message.warning('已经有默认联系人，保存会以当前目的港指定货代理为默认值')
      //   }
      // }
    },
    async saveSub() {
      const form = this.editDialog.form
      /* 验证同一个目的港是否同时设置多个默认指定货代理 */
      const list = [...this.rowData]
      const index = list.findIndex(p => p.seq === form.seq)
      if (index >= 0) {
        list[index] = form
      } else {
        list.push(form)
      }
      const obj = {}
      let isSame = false
      for (const p of list) {
        if (!p.destinationPort) {
          if (p.defaultAgent) {
            if (obj.default) {
              isSame = true
              break
            } else {
              obj.default = true
            }
          }
        } else {
          if (p.defaultAgent) {
            if (obj[p.destinationPort]) {
              isSame = true
              break
            } else {
              obj[p.destinationPort] = true
            }
          }
        }
      }
      if (isSame) {
        this.$message.warning('同一目的港仅能设置一个默认指定货代理')
        return
      }
      const row = this.rowData.find(item => item.seq === form.seq)
      if (row) {
        Object.assign(row, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      this.editDialog.visible = false
    },
    customerTypeIdFunc(data) {
      this.form.customerTypeId = data.typeId
    },
    remove() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.finalRowData[cell.rowIndex] : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        this.rowData.splice(index, 1)
        if (row.uuid) {
          this.deletedPortDestinationAgentKeys.push(row.uuid)
        }
      }).catch(() => { })
    },
    saveFactorySign() {
      if (!this.factorySign.rowData) {
        this.factorySign.rowData = []
      }
      if (!this.factorySign.addDialog.factorySignValue || this.factorySign.addDialog.factorySignValue.length === 0) {
        this.$message.warning(this.$t('Pricing.PlsInput', [this.$t('Partners.Factory')]))
        return
      }
      for (const value of this.factorySign.addDialog.factorySignValue) {
        const list = this.factorySign.rowData.filter(p => p.factorySignCmpIdx === value)
        if (list.length === 0) {
          const data = {
            uuid: '',
            cmpIdx: this.company.cmpIdx,
            factorySignCmpIdx: value,
            deleted: false
          }
          this.factorySign.rowData.push(data)
        }
      }
      this.factorySign.addDialog.visible = false
    },
    factorySignAddDialog() {
      this.factorySign.addDialog.factorySignValue = 0
      this.factorySign.addDialog.title = this.$t('CargoMsg.Cargo_AddAssociatedFactory')
      this.factorySign.addDialog.visible = true
    },
    factorySignAddRemove() {
      const cell = this.factorySign.gridApi.getFocusedCell()
      const row = cell ? this.companyFactorySigns[cell.rowIndex] : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('Message.SureDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.companyFactorySigns.findIndex(p => p.factorySignCmpIdx === row.factorySignCmpIdx)
        this.factorySign.rowData.splice(index, 1)
        if (row.uuid) {
          this.deletedFactorySignKeys.push(row.uuid)
        }
      }).catch(() => { })
    }
  }
}
</script>

<style scoped lang="scss">
.customer-form {
  &.section {
    padding: 20px;
  }
  .box {
    position: relative;
    padding-top: 10px;
    flex: 1;
    margin: 0 5px;
    max-width: 750px;
    .box-label {
      position: absolute;
      left: 10px;
      top: 0;
      padding: 0 5px;
      border-radius: 3px;
      font-size: 13px;
      line-height: 20px;
      background: #f5f7fa;
      color: #404144;
    }
    .box-content {
      width: 100%;
      border: 1px solid #ababab;
      border-radius: 5px;
      padding: 0;
      padding-top: 10px;
    }
  }
  .el-select {
    width: 100%;
  }
  .form-item-350 ::v-deep {
    .el-form-item__content {
      width: 350px;
      .el-date-editor.el-input {
        width: 250px;
      }
    }
  }
  .form-item-430 ::v-deep {
    .el-form-item__content {
      width: 430px;
    }
  }
  .margin-Right50 {
    margin-right: 50px;
  }
}
</style>
